import React from 'react';
import PropTypes from 'prop-types';
import { getDefaultAdAlt } from '../../../../utils/ads/adsUtils';

const NativeAd = ({ adParams, adSlot }) => {
  const adId = `ad-${adSlot}`;
  return (
    <div id={adId} className={adParams[adSlot].classes}>
      <a key={Math.random()} className="adslot-target" href={adParams[adSlot].placement.redirect_url} rel="noopener noreferrer"
         target="_blank" dangerouslySetInnerHTML={{ __html: adParams[adSlot].placement.body }} />
      {
        adParams[adSlot].placement.tracking_pixel &&
        <img alt={getDefaultAdAlt(`${adId}-pixel`)} className="tracking-pixel" src={adParams[adSlot].placement.tracking_pixel} />
      }
    </div>
  );
};

NativeAd.propTypes = {
  adParams: PropTypes.object,
  adSlot: PropTypes.string
};

export default NativeAd;
